import { Button } from "@/components/ui/button";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import { useState } from "react";
import { X } from "lucide-react";

interface Classroom {
  id: string;
  name: string;
}

interface BulkAssignToolbarProps {
  selectedCount: number;
  classrooms: Classroom[];
  onAssign: (classroomId: string) => void;
  onClearSelection: () => void;
}

export function BulkAssignToolbar({ selectedCount, classrooms, onAssign, onClearSelection }: BulkAssignToolbarProps) {
  const [selectedClassroom, setSelectedClassroom] = useState("");

  if (selectedCount === 0) return null;

  return (
    <div className="flex items-center gap-3 bg-blue-50 dark:bg-blue-950/30 border border-blue-200 dark:border-blue-800 rounded-lg px-4 py-2 mb-3">
      <span className="text-sm font-medium text-blue-700 dark:text-blue-300">
        {selectedCount} student{selectedCount !== 1 ? "s" : ""} selected
      </span>
      <Select value={selectedClassroom} onValueChange={setSelectedClassroom}>
        <SelectTrigger className="h-8 w-[200px] text-sm">
          <SelectValue placeholder="Select classroom..." />
        </SelectTrigger>
        <SelectContent>
          {classrooms.map((c) => (
            <SelectItem key={c.id} value={c.id}>{c.name}</SelectItem>
          ))}
        </SelectContent>
      </Select>
      <Button
        size="sm"
        disabled={!selectedClassroom}
        onClick={() => {
          onAssign(selectedClassroom);
          setSelectedClassroom("");
        }}
      >
        Assign
      </Button>
      <Button variant="ghost" size="sm" onClick={onClearSelection}>
        <X className="w-4 h-4" />
        Clear
      </Button>
    </div>
  );
}
